import { mapState } from 'vuex';
export default {
  name: 'KeyValueField',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    keyValue: {
      type: [String, Number],
      default: ''
    },
    hasKeyOptions: {
      type: Boolean,
      default: false
    },
    keyOptions: {
      type: Array,
      default: () => []
    },
    hasValueOptions: {
      type: Boolean,
      default: false
    },
    valueOptions: {
      type: Array,
      default: () => []
    },
    isLoadingKeyOptions: {
      type: Boolean,
      default: false
    },
    isLoadingValueOptions: {
      type: Boolean,
      default: false
    },
    keyPlaceholder: {
      type: String,
      default: ''
    },
    keySearchTerm: {
      type: String,
      default: ''
    },
    valuePlaceholder: {
      type: String,
      default: ''
    },
    valueSearchTerm: {
      type: String,
      default: ''
    },
    canLoadMoreKeyOptions: {
      type: Boolean,
      default: false
    },
    isLoadingMoreKeyOptions: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    canAddRule: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    keySearchInputSync: {
      get() {
        return this.keySearchTerm;
      },
      set(value) {
        this.$emit('key-search-input', value);
      }
    },
    valueSearchInputSync: {
      get() {
        return this.valueSearchTerm;
      },
      set(value) {
        this.$emit('value-search-input', value);
      }
    }
  },
  methods: {
    onKeyIntersect(entries) {
      if (entries[0].isIntersecting) {
        this.$emit('key-intersect', entries);
      }
    }
  }
};